import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const AlertStatus = ({ is_active }) => {
  let color = is_active ? '#00C800' : '#A6ADB3';
  let text = is_active ? 'On' : 'Off';
  return (
    <div>
      <FontAwesomeIcon icon="circle" color={color} /> {text}
    </div>
  );
};

const ListSmsConfigs = ({ configs }) => {
  const columns = [
    {
      id: 'user_name',
      Header: 'Name',
      sortable: true,
      accessor: ({ user_name }) => user_name,
    },
    {
      id: 'user_role',
      Header: 'Business Account',
      sortable: true,
      accessor: ({ user_role }) => user_role,
    },
    {
      id: 'sms_alert_number',
      Header: 'Phone Number',
      sortable: true,
      accessor: ({ sms_alert_number }) => sms_alert_number,
    },
    {
      id: 'is_active',
      Header: 'Alert Status',
      sortable: true,
      Cell: ({ original: { is_active } }) => (
        <AlertStatus is_active={is_active} />
      ),
    },
    {
      id: 'alert_type',
      Header: 'Alerts',
      sortable: true,
      accessor: ({ alert_type: alertType }) => {
        const types = alertType.map(alert => alert.replace('_', ' '));
        return (
          <div style={{ whiteSpace: 'normal' }} className="text-capitalize">
            {types.join(', ')}
          </div>
        );
      },
    },
  ];

  const minRows = configs.length ? 0 : 2;

  return (
    <div>
      <ReactTable
        className="styled-box-shadow bg-white"
        data={configs}
        columns={columns}
        resizable={false}
        sortable={false}
        minRows={minRows}
        showPagination={false}
      />
    </div>
  );
};

ListSmsConfigs.propTypes = {
  configs: PropTypes.arrayOf(
    PropTypes.shape({
      is_active: PropTypes.bool,
      sms_alert_number: PropTypes.string,
      alert_type: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default ListSmsConfigs;



// WEBPACK FOOTER //
// ./src/components/emailConfig/list/ListSmsConfigs.js